import { FETCH_AVAILABLE_LEAD_KEYS } from "../actions/clientHandler.action.js";

const defaultState = {
  clientHandlerLeadKeys: [],
};

const reducer = (state = defaultState, action) => {
  switch (action.type) {
    case FETCH_AVAILABLE_LEAD_KEYS:
      return {
        ...state,
        clientHandlerLeadKeys: action.payload,
      };
  }
};

export default reducer;
